/**
 * The Stats page's tabs and their routes, light enough for the route transition to read: the three routes are ONE page
 * (the tab row stays put and only the open tab's content slides beneath it, see `pages/stats`), so `PageTransition`
 * does not slide the whole page between them.
 */
import { ROUTE } from '../../routes';

export type StatsTab = 'stats' | 'pulse' | 'website';

/** The tabs in their row's order (a slide goes the way the row reads). */
export const STATS_TABS: readonly StatsTab[] = ['stats', 'pulse', 'website'];

/** The tab a route opens, or null when it is not one of the Stats page's routes. Pure. */
export const statsTabOfPath = (pathname: string): StatsTab | null => {
  const path = pathname.replace(/\/+$/, '');
  if (path === ROUTE.pulse()) return 'pulse';
  if (path === ROUTE.statsWebsite()) return 'website';
  if (path === ROUTE.stats()) return 'stats';
  return null;
};

/** Whether `pathname` is one of the Stats page's tab routes. Pure. */
export const isStatsTabPath = (pathname: string): boolean => statsTabOfPath(pathname) !== null;
